import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import * as Dati from "../../Dati";
import ChiamaWeb, { CChiamaWebParametri } from "../../ChiamaWeb";
import { Trad } from "../../components/";

interface IAutocompleteProps {
    Label: string;
    Name: string;
    Url: string;
    Value: string | number;
    OnChange: (e: string, val: unknown) => void;
    Disabled?: boolean;
    Multiple?: boolean;
    SearchInput?: boolean;
    TranslationsOff?: boolean;
}

export const _Autocomplete: React.FC<IAutocompleteProps> = ({ Disabled, Label, Name, Url, Value, OnChange, Multiple, SearchInput, TranslationsOff }) => {
    const [Loading, setLoading] = useState(false);
    const [Options, setOptions] = useState<Dati.CTipo[]>([]);
    const [InputValue, setInputValue] = useState(Value);
   /* console.warn("valore", Value);*/

    const getOptions = (val: string | number) => {
        const Param: CChiamaWebParametri = {
            URL: `${Url}${SearchInput ? "" : encodeURIComponent(val)}`,
            OnRis: (sender: ChiamaWeb, data: Dati.CRisAPIListaTipo) => {
                const options: any[] = [];

                for (let key in data.Dati) {
                    options.push(data.Dati[key]);
                }
                setOptions(options);
                setLoading(false);
            }
        };
        setLoading(true);
        new ChiamaWeb().Chiama(Param);
    };
    useEffect(() => {
        if (!SearchInput && Value != InputValue) {
            getOptions(InputValue);
        }
    }, [InputValue]);

    useEffect(() => {
        if (!SearchInput) {
            getOptions(Value);
        }
    }, [Value]);

    useEffect(() => {
        if (SearchInput) {
            getOptions(Value);
        }
    }, [Url]);

    const getValue = (value: string | number | null): Dati.CTipo | Dati.CTipo[] => {
        if (Multiple && value) {
            const values = JSON.parse(value.toString());

            return Options.filter(option => values.indexOf(option.ID_Chiave) != -1);
        }
        return Options.filter(option => option.ID_Chiave == value)[0] || null;
    };

    const onSelectChange = (val: Dati.CTipo | Dati.CTipo[]) => {
        if (Multiple) {
            const values: string[] = [];

            (val as Dati.CTipo[]).forEach(item => {
                values.push(item.ID_Chiave);
            });
            OnChange(Name, JSON.stringify(values));
        } else {
            OnChange(Name, (val as Dati.CTipo)?.ID_Chiave || "");
        }
    };

    return (
        <Autocomplete
            multiple={Multiple}
            freeSolo={SearchInput}
            options={Options}
            disabled={Disabled}
            value={getValue(Value)}
            onChange={(e, val: Dati.CTipo | Dati.CTipo[]) => {
                onSelectChange(val);
            }}
            onInputChange={(e, v, reason) => {
                if (reason === "input") {
                    setInputValue(v);
                }
            }}
            getOptionSelected={(option: Dati.CTipo, value: Dati.CTipo) => option.ID_Chiave === value.ID_Chiave}
            getOptionLabel={(option: Dati.CTipo) => (TranslationsOff ? option.Valore : Trad.TradParam(option.Valore, option.Parametri))}
            renderInput={params => (
                <TextField
                    {...params}
                    name={Name}
                    label={Trad.Trad(Label)}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {Loading ? <CircularProgress color="inherit" size={15} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />
            )}
            fullWidth
        />
    );
};



// WEBPACK FOOTER //
// ./src/inar2/form/Autocomplete.tsx